import { sortBy } from 'lodash';

export default {
  data() {
    return {
      currentLocale: undefined,
      availableLocales: [
        {
          lang: 'nl', // nl-NL
          text: this.$t(`attribute_options.default_locale.nl`),
          flag: '🇳🇱', // flag emoji combination
        },
        {
          lang: 'en', // en-GB of en-US ?
          text: this.$t(`attribute_options.default_locale.en`),
          flag: '🇬🇧', // flag emoji combination
        },
        {
          lang: 'el', // el-CY of el-GR ?
          text: this.$t(`attribute_options.default_locale.el`),
          flag: '🇬🇷', // flag emoji combination
        },
        {
          lang: 'de', // de
          text: this.$t(`attribute_options.default_locale.de`),
          flag: '🇩🇪', // flag emoji combination
        },
        {
          lang: 'cn', // zh-CN
          text: 'Chinese',
          flag: '🇨🇳', // flag emoji combination
        },
      ],
      supportedLocales: sortBy(
        [
          {
            lang: 'nl', // nl-NL
            text: 'Nederlands',
            flag: '🇳🇱', // flag emoji combination
          },
          {
            lang: 'en', // en-GB of en-US ?
            text: 'English',
            flag: '🇬🇧', // flag emoji combination
          },
          {
            lang: 'el', // el-CY of el-GR ?
            text: 'Ελληνικά',
            flag: '🇬🇷', // flag emoji combination
          },
          {
            lang: 'cn', // zh-CN
            text: 'Chinese',
            flag: '🇨🇳', // flag emoji combination
          },
        ],
      ),
    };
  },
  methods: {
    isLocale(value) {
      const normalizedValue = String(value || '').toLowerCase();
      this.currentLocale = this.availableLocales.find(locale => {
        const valueBase = normalizedValue.split('-')[0];
        return locale.lang.toLowerCase() === valueBase;
      });
      return this.currentLocale;
    },
  },
};
